import { Pipe, PipeTransform } from '@angular/core';
import { fromSecondsToTimeString } from '../../core/utils';

@Pipe({
    name: 'timeRange',
    standalone: true
})
export class TimeRangePipe implements PipeTransform {
  transform(value: string, shortForm: boolean = false, ...args: unknown[]): unknown {
    return fromSecondsToTimeString(value,shortForm);
  }
}
